import { prop } from 'ramda';
import { useCallback } from 'react';
import { useAppSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetGeoIP = () => {
    const send = useGenericSend();
    const casinoName = useAppSelector(prop('casinoName'));

    return useCallback(async () => {
        const { data: {
            country, resolvedProperties = []
        } } = await send<Types.IGetGeoIPRequestData, Types.IGetGeoIPResponseData>({
            ID: 35685,
            casino: casinoName,
            description: 'Country by Geo IP detection',
            responses: [35686, 35687]
        });

        return { country, resolvedProperties };
    }, [casinoName, send]);
};
